var render, staticRenderFns
import script from "./DescriptionsItem.vue?vue&type=script&lang=js&"
export * from "./DescriptionsItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69e62336",
  null
  
)

export default component.exports